import type { WhiteboardDocumentId } from "@src/components/collaboration/document-id";
import { WhiteboardStatus } from "@src/gql/graphql";

export const whiteboardQueryKeys = {
	all: ["whiteboards"] as const,
	allMy: () => [...whiteboardQueryKeys.all, "my"] as const,
	ofId: (id: string) => ["whiteboards", id],
	owned: (userId?: string, shareKey: string | null = null) =>
		userId
			? [...whiteboardQueryKeys.allMy(), "owned", userId, shareKey]
			: [...whiteboardQueryKeys.allMy(), "owned"],
	active: (userId?: string, shareKey: string | null = null) =>
		userId
			? [...whiteboardQueryKeys.allMy(), "active", userId, shareKey]
			: [...whiteboardQueryKeys.allMy(), "active"],
	shared: () => [...whiteboardQueryKeys.all, "shared"],
	published: (
		whiteboardId: WhiteboardDocumentId | null,
		shareKey: string | null,
	) => ["publishedWhiteboard", whiteboardId?.toIdString() ?? "", shareKey],
	checkPermission: (whiteboardId: string, sharingKey: string | null) => [
		...whiteboardQueryKeys.all,
		"checkPermission",
		whiteboardId,
		sharingKey,
	],
	templates: () => [...whiteboardQueryKeys.all, "templates"],
};

export const trashQueryKeys = {
	all: () => ["trash"] as const,
	items: () => [...trashQueryKeys.all(), "items"] as const,
};

export const trashMutationKeys = {
	all: () => ["trash-mutations"] as const,
};

export { WhiteboardStatus };
